import { errorMessagesProxy } from "@/utils/helpers";

export const APP_SETTING_ERRORS = errorMessagesProxy({
  GENERIC_ERROR: "Sorry, there has been a problem with that request.",
});
